<template>
    <div class="home">
        <dv-full-screen-container class="bg">
            <div class="top">
                <div class="time" :style="{ color: $store.state.maxThemeColor }">{{ time }}</div>
                <div class="title">
                    <dv-decoration-5 :color="[$store.state.maxThemeColor, $store.state.maxThemeColor]"
                        style="width: 100%; height: 2rem" :dur="5"></dv-decoration-5>
                    <span class="titleText" :style="{ color: $store.state.maxThemeColor }">{{ $store.state.maxTitle
                        }}</span>
                </div>
                <div class="menu">
                    <div class="menuList">
                        <div class="icon">
                            <img src="@/assets/fullscreen.png" title="全屏" alt="全屏" />
                        </div>
                        <div @click="fullPage" class="text">全屏</div>
                    </div>

                    <div class="menuList" style="cursor: default">
                        <div class="icon">
                            <img src="@/assets/admin.png" title="管理员" alt="管理员" />
                        </div>
                        <!-- <div class="text">{{ userInfo.username }}</div> -->
                        <div class="text">{{ username }}</div>
                    </div>

                    <div class="menuList" style="cursor: default">
                        <div class="icon">
                            <img src="@/assets/sss.png" title="切换新版" alt="切换新版" />
                        </div>
                        <!-- <div class="text">{{ userInfo.username }}</div> -->
                        <div class="text" @click="$router.push('/ANewMaxWeb')">切换新版</div>
                    </div>

                    <div class="menuList">
                        <div class="icon">
                            <img src="@/assets/adminSystem.png" title="管理员后台" alt="管理员后台" />
                        </div>
                        <div @click="goAdminSystem" class="text">管理员后台</div>
                    </div>

                    <div class="menuList">
                        <div class="icon">
                            <img src="@/assets/exit.png" title="退出" alt="退出" />
                        </div>
                        <div @click="loginOut" class="text">退出</div>
                    </div>
                </div>
            </div>
            <div class="midf">
                <div class="left">
                    <dv-border-box-7>
                        <div class="top">
                            <loading></loading>
                            <div class="content">
                                <div class="contentBox">
                                    <div class="contentlist">
                                        设备总数：{{
                    computerDataObj.normalNumber + computerDataObj.maintainNumber +
                    computerDataObj.troubleNumber
                }}
                                    </div>
                                    <div class="contentlist">正常设备：{{ computerDataObj.normalNumber }}</div>
                                    <div class="contentlist">故障设备：{{ computerDataObj.troubleNumber }}</div>
                                    <div class="contentlist">维护设备：{{ computerDataObj.maintainNumber }}</div>
                                </div>
                            </div>
                        </div>
                        <dv-decoration-8 :color="['#2c3e50', '#2c3e50']" :reverse="true"
                            style="width: 100%; height: 0.8rem" />
                        <div class="bot" ref="deviceStatus"></div>
                    </dv-border-box-7>
                </div>
                <div class="map">
                    <dv-border-box-7 id="containerBox">
                        <div class="mapBox" id="container" ref="container"></div>
                    </dv-border-box-7>
                </div>
                <div class="right">
                    <dv-border-box-7>
                        <div class="top">
                            <div class="left">
                                <img src="@/assets/report01.png" alt />
                                <div class="text">
                                    <div class="ttitle">当前报警</div>
                                    <div class="number">{{ messageData.length }}</div>
                                </div>
                            </div>
                            <div class="right">
                                <img src="@/assets/report02.png" alt />
                                <div class="text">
                                    <div class="ttitle">正常设备</div>
                                    <div class="number">
                                        {{
                    computerDataObj.normalNumber +
                    computerDataObj.maintainNumber +
                    computerDataObj.troubleNumber -
                    messageData.length
                }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <dv-decoration-8 :color="['#2c3e50', '#2c3e50']" style="width: 100%; height: 0.8rem" />
                        <div class="bot">
                            <div class="botBtn">
                                <!-- <div class="boxtttt">
                                    报警信息
                                </div>-->
                                <!-- <div class="botBtn1" @click="changeMessageBtn('fail')">
                                    <img src="@/assets/t_border.png" alt />
                                    <div :class="messageBtnClassFail ? 'botText selectBotText' : 'botText'">报警信息</div>
                                </div>
                                <div class="botBtn2" @click="changeMessageBtn('success')">
                                    <img src="@/assets/t_border.png" alt />
                                    <div :class="messageBtnClassSuccess ? 'botText selectBotText' : 'botText'">已处理</div>
                                </div>-->
                            </div>
                            <div class="botCon">
                                <div v-if="messageData.length == 0">没有报警信息</div>
                                <div class="botConList" v-for="item in messageData" @click="messDetail(item)"
                                    :key="item.id">
                                    <span :class="item.type == 'alarm' ? 'alarm' : 'troule'">[{{ item.info }}]</span>
                                    &nbsp;&nbsp;
                                    {{ item.failDate }}&nbsp;&nbsp; {{ item.id }}
                                </div>
                            </div>
                        </div>
                    </dv-border-box-7>
                </div>
            </div>
            <div class="bot">
                <div class="one botL" ref="one"></div>
                <div class="two botL" ref="two"></div>
                <div class="three botL" ref="three"></div>
                <div class="four botL" ref="four"></div>
            </div>

            <!-- 切换marker图标显示类型 -->
            <el-dialog title="选择地图中的定位标记点类型" :close-on-press-escape="false" :visible.sync="markerTypeDialogVisible"
                width="30%" :modal="false">
                <el-radio-group v-model="radioMarkerType">
                    <el-tooltip class="item" effect="dark" content="根据设备的在线状态进行地图标记点显示,共有三种状态:正常/故障/维护"
                        placement="bottom">
                        <el-radio :label="1">在线状态</el-radio>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="根据设备的报警状态进行地图标记点显示,共有两种状态:报警/正常" placement="bottom">
                        <el-radio :label="-1">报警状态</el-radio>
                    </el-tooltip>
                </el-radio-group>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="markerTypeDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="changeMapMarker">确 定</el-button>
                </span>
            </el-dialog>
        </dv-full-screen-container>
    </div>
</template>

<script>
import { GetDeviceData, QueryAlermMessage, QueryCompanyProject } from '../../api/index';
// @ is an alias to /src
import loading from '@/components/common/loading.vue';
// import * as echarts from "echarts";
import screenfull from 'screenfull';
import ElementUI from 'element-ui';
import { Bigscreen } from '../../api';
import GCJ02_WGS84 from '@/utils/GCJ02_WGS84.js';

import moment from 'moment';
// import {Socket} from '@/utils/webSocket.js'
export default {
    name: 'HomeView',
    data() {
        return {
            username: JSON.parse(localStorage.getItem('userinfo')).name,
            // 报警信息数据
            alermMessageData: [],
            // 单选框选择中的地图marker显示类型  1为在线状态 -1为报警状态
            radioMarkerType: 1,
            // 应该显示的地图marker显示类型
            markerType: this.$store.state.maxMarkerType * 1,
            // 是否打开切换图标类型的弹窗
            markerTypeDialogVisible: false,
            // socket对象
            webSocket: '',
            // 用户信息
            userInfo: JSON.parse(localStorage.getItem('info')),
            // 设备数据
            deviceData: [],
            // 统计设备状态数量
            computerDataObj: {},
            // 定时器
            timer: '',
            // ------------------

            DeviceCountStatus: [{ value: 0 }, { value: 0 }, { value: 0 }],
            messageAll: 0, //报警总数
            messageSuccess: 0, // 已处理数量,
            messageBtnClassFail: true,
            messageBtnClassSuccess: false,
            // 页面全屏
            fullscreen: false,
            // 地图全屏
            mapFullscreen: false,
            searchDeviceData: {
                status: '',
                type: ''
            },
            time: moment(new Date()).format('YYYY-MM-DD HH:mm '),
            mapContle: '',
            messageData: {}
        };
    },
    components: {
        loading
    },
    created() {
        this.getDeviceData();
        // this.typeComputer();
        // 时间显示
        setInterval(() => {
            this.time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        }, 1000);
    },
    mounted() {
        let that = this;
        setTimeout(() => {
            let myChart = this.$echarts.init(this.$refs.deviceStatus);

            // 本月报警次数统计
            this.beforDeviceDataComputerLine();
            // 城市分布统计
            this.cityGeocoder();

            // 处理设备状态统计所需数据并渲染
            // this.statusComputer();

            // let one = this.$echarts.init(this.$refs.one);
            let two = this.$echarts.init(this.$refs.two);
            let three = this.$echarts.init(this.$refs.three);

            // 绘制设备状态统计图表
            myChart.setOption({
                grid: {
                    bottom: 25
                },
                title: {
                    text: '设备状态统计',
                    left: 'center',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                // legend: {
                //     orient: 'vertical',
                //     left: 0,
                //     textStyle: {
                //         color: '#ffffff'
                //     }
                // },
                series: [
                    {
                        name: '设备状态数量',
                        type: 'pie',
                        radius: '50%',
                        data: this.statusComputer(),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            // 设备分类统计
            three.setOption({
                grid: {
                    bottom: 25
                },
                title: {
                    text: '设备分类统计',
                    left: 'left',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                // legend: {
                //     orient: 'vertical',
                //     left: 'right',
                //     textStyle: {
                //         color: '#ffffff'
                //     }
                // },
                series: [
                    {
                        name: '设备种类',
                        type: 'pie',
                        radius: '50%',
                        data: this.typeComputer(),
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });

            // 地图操作
            this.bMap();
            let that = this;
            // 动态设置hover
            let menuListDoms = document.querySelectorAll('.menuList .text');
            for (let i = 0; i < menuListDoms.length; i++) {
                menuListDoms[i].onmouseover = function () {
                    this.style.color = that.$store.state.maxThemeColor;
                };
                menuListDoms[i].onmouseout = function () {
                    this.style.color = '#ffffff';
                };
            }
            // 左上角设备统计
            // let contentlistDoms = document.querySelectorAll('.contentlist');
            // for (let i = 0; i < contentlistDoms.length; i++) {
            //     contentlistDoms[i].onmouseover = function() {
            //         this.style.color = that.$store.state.maxThemeColor;
            //     };
            //     contentlistDoms[i].onmouseout = function() {
            //         this.style.color = '#ffffff';
            //     };
            // }
            let botConListDoms = document.querySelectorAll('.botConList');
            for (let i = 0; i < botConListDoms.length; i++) {
                botConListDoms[i].onmouseover = function () {
                    this.style.color = that.$store.state.maxThemeColor;
                };
                botConListDoms[i].onmouseout = function () {
                    this.style.color = '#ffffff';
                };
            }
        }, 2000);
        this.timer = setInterval(() => {
            that.getDeviceData();
            that.statusComputer();
            // that.bMap();
            that.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
        }, 1000 * 60 * 5);
    },
    methods: {
        // 修改图标显示类型
        changeMapMarker() {
            // 如果发生了改变 开始切换类型
            if (this.radioMarkerType != this.markerType) {
                console.log('改变了');
                this.markerType = this.radioMarkerType;
                switch (this.radioMarkerType) {
                    case 1:
                        this.$message.warning('修改为在线状态');
                        this.markerTypeDialogVisible = false;
                        // 销毁地图
                        this.mapContle.destroy();
                        // 重新构建
                        this.bMap();
                        break;
                    case -1:
                        this.$message.warning('修改为报警状态');
                        this.markerTypeDialogVisible = false;
                        // 销毁地图
                        this.mapContle.destroy();
                        // 重新构建
                        this.bMap();
                        break;
                    default:
                        break;
                }
            } else {
                console.log('未改变');
                this.$message.warning('未改变标记点类型');
                this.markerTypeDialogVisible = false;
            }
        },
        // ws操作
        // webSocketF() {
        //     let url = 'ws://39.107.84.228:9007/echo';
        //     this.webSocket = new WebSocket('ws://39.107.84.228:9007/echo');
        //     console.log(this.webSocket);
        //     this.webSocket.send('12312321321312');
        //     this.webSocket.onopen = (e) => {
        //         console.log('正在连接');
        //         console.log(e.currentTarget.readyState);

        //         if (e.currentTarget.readyState == 1) {
        //             // 连接建立
        //             this.webSocket.send('12312321321312');
        //         }
        //     };
        //     this.webSocket.onmessage = (e) => {
        //         console.log('接受倒数据');
        //         console.log(e);
        //         // 修改报警信息
        //     };
        //     this.webSocket.onerror = (e) => {
        //         this.$message.error('服务器连接错误');
        //         console.log(e);
        //     };
        //     this.webSocket.onclose = (e) => {
        //         // 连接关闭
        //         console.log('连接关闭');
        //     };
        // },

        // 获取设备数据
        async getDeviceData() {
            let companyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            let DevicelistResult = await GetDeviceData({ companyId });
            if (DevicelistResult.code !== 200) {
                this.$message.error('获取设备数据错误');
                return;
            }
            // 设备数据处理完成
            this.deviceData = DevicelistResult.data;
            // 修改vuex中的设备数据
            this.$store.commit('setDeviceNowData', DevicelistResult.data);

            // -----

            // 判断是否有设备是否触发报警条件 如果触发则修改报警记录
            let messageArr = [];
            this.deviceData.forEach((item, index) => {
                switch (item.deviceType) {
                    case '智能井盖':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '井盖打开',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                lat: item.longitude * 1,
                                lng: item.latitude * 1,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '水位流速监测':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '水位超限',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                lat: item.longitude * 1,
                                lng: item.latitude * 1,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    case '雨量监测':
                        if (item.alarmStatus) {
                            messageArr.push({
                                messageId: index,
                                type: 'alarm',
                                info: '雨量超限',
                                id: item.anotherName ? item.anotherName : item.deviceName,
                                lat: item.longitude * 1,
                                lng: item.latitude * 1,
                                failDate: moment(item.updateTime * 1).format('MM/DD HH:mm '),
                                successDate: '',
                                status: 0
                            });
                        }
                        break;
                    default:
                        break;
                }
            });
            this.$store.commit('setAlarmMessage', messageArr);

            this.messageData = this.$store.state.deviceMessage;
        },

        // 获取过去七天日期包含今天
        // getLastOrNextFewDateBy(value) {
        //     this.timeList = [];
        //     let timedate = value !== '' ? value : this.bigtime !== '' ? this.bigtime : '';
        //     for (let i = -7; i <= 0; i++) {
        //         let today = new Date();
        //         if (timedate) {
        //             this.receiver = timedate;
        //         } else {
        //             this.receiver = today;
        //         }
        //         let lastOrNextDate = this.receiver.getTime() + 1000 * 60 * 60 * 24 * i;
        //         today.setTime(lastOrNextDate);
        //         // var year = today.getFullYear();
        //         let month = today.getMonth() + 1;
        //         if (this.receiver == timedate) {
        //             let date = today.getDate();
        //             if (date < 10) {
        //                 date = '0' + date;
        //             }
        //             if (month < 10) {
        //                 month = '0' + month;
        //             }
        //             this.timeList.push(month + '-' + date);
        //         } else {
        //             let date = today.getDate() - 1;
        //             if (date < 10) {
        //                 date = '0' + date;
        //             }
        //             if (month < 10) {
        //                 month = '0' + month;
        //             }
        //             this.timeList.push(month + '-' + date);
        //         }
        //         // this.timeList.push(i != 0 ? month + "月" + date + '日' : '本日')
        //         // this.timeList.push(month + "月" + date + '日')
        //     }
        //     return this.timeList;
        // },

        // -------------

        loginOut() {
            localStorage.clear();
            localStorage.clear();
            this.$router.push('/login');
        },
        // 地图初始化流程
        bMap() {
            // var myChart = this.$echarts.init(this.$refs.container);
            // var option;

            // this.$echarts.registerMap('china', require('@/utils/echartsMap/chinaChange.json'));
            // myChart.setOption(
            //     (option = {
            //         // tooltip: {
            //         //     trigger: 'item',
            //         //     formatter: '{b}<br/>{a}'
            //         // },
            //         visualMap: {
            //             min: 0,
            //             max: 1000,
            //             text: ['High', 'Low'],
            //             realtime: false,
            //             calculable: true,
            //             show: false,
            //             inRange: {
            //                 color: ['#00ccff', '#0099ff', '#0066ff']
            //             }
            //         },
            //         series: [
            //             {
            //                 name: '中国地图',
            //                 type: 'map',
            //                 map: 'china',
            //                 label: {
            //                     show: false
            //                 },
            //                 colorBy: 'series',
            //                 itemStyle: {
            //                     areaColor: '#00ffff',
            //                     borderColor: '#000000'
            //                 },
            //                 select: {
            //                     disabled: true, //不可以被选中
            //                 },
            //                 emphasis: {
            //                     label: {
            //                         show: false
            //                     }
            //                 },

            //                 data: [
            //                     { name: '山西', value: 30 },
            //                     { name: '陕西', value: 800 },
            //                     { name: '北京', value: 2 }
            //                 ],
            //             }
            //         ]
            //     }));

            var map = new T.Map('container');
            this.mapContle = map;
            this.mapContle.centerAndZoom(
                new T.LngLat(this.$store.state.maxMapSetting.Lng * 1, this.$store.state.maxMapSetting.Lat * 1),
                this.$store.state.maxMapSetting.zIndex * 1
            );
            this.mapContle.setStyle('black');
            // 添加内置控件
            //创建缩放平移控件对象
            var control = new T.Control.Zoom();
            //添加缩放平移控件
            this.mapContle.addControl(control);
            //创建比例尺控件对象
            var scale = new T.Control.Scale();
            //添加比例尺控件
            this.mapContle.addControl(scale);
            //创建对象
            var ctrl = new T.Control.MapType();
            //添加控件
            this.mapContle.addControl(ctrl);

            // 设置marker 初始化地图为全部marker
            this.setMapMarker(this.$store.state.maxMarkerType * 1, this.$store.state.deviceNowData);
        },

        // 设置地图marker
        setMapMarker(type, data) {
            // type == 1 在线状态  type==-1报警状态
            let map = this.mapContle;
            map.clearOverLays();

            //创建图片对象

            var orangeIcon = new T.Icon({
                iconUrl: require('@/assets/mark2.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var redIcon = new T.Icon({
                iconUrl: require('@/assets/mark3.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var greenIcon = new T.Icon({
                iconUrl: require('@/assets/mark1.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var jinggaiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggaio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var jinggaiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/jinggair.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var shuiweiGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweig.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweio.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var shuiweiRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/shuiweir.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            var yuliangGreenIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangg.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangOrangeIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliango.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });
            var yuliangRedIcon = new T.Icon({
                iconUrl: require('@/assets/icon/yuliangr.png'),
                iconSize: new T.Point(25, 27),
                iconAnchor: new T.Point(12, 25)
            });

            // 判断当前是根据什么状态进行marker图标显示
            if (type === 1) {
                // 在线状态
                data.forEach((item, index) => {
                    let gcj02towgs84 = GCJ02_WGS84.gcj02towgs84(item.latitude * 1, item.longitude * 1);
                    console.log('gcj02towgs84', gcj02towgs84);

                    // var latlng = new T.LngLat(item.latitude * 1, item.longitude * 1);
                    var latlng = new T.LngLat(gcj02towgs84[0], gcj02towgs84[1]);
                    var marker = '';
                    var infoWin1 = new T.InfoWindow();

                    let deviceDetailPagePath = '';
                    switch (item.deviceType) {
                        case '智能井盖':
                            deviceDetailPagePath = 'ADeviceDetail';
                            break;
                        case '水位流速监测':
                            deviceDetailPagePath = 'ADeviceDetail1';
                            break;
                        case '雨量监测':
                            deviceDetailPagePath = 'ADeviceDetail2';
                            break;

                        default:
                            break;
                    }

                    switch (item.deviceType) {
                        case '智能井盖':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: jinggaiOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: jinggaiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: jinggaiGreenIcon });
                            }
                            break;
                        case '水位流速监测':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: shuiweiOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: shuiweiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: shuiweiGreenIcon });
                            }
                            break;
                        case '雨量监测':
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: yuliangOrangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: yuliangRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: yuliangGreenIcon });
                            }
                            break;

                        default:
                            if (item.maintain === '1') {
                                // 维护状态
                                marker = new T.Marker(latlng, { icon: orangeIcon });
                            } else if (new Date().getTime() - item.updateTime * 1 > 7776000000) {
                                // 故障状态
                                marker = new T.Marker(latlng, { icon: redIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: greenIcon });
                            }
                            break;
                    }

                    var sContent = `
                       <div style="font-Size:16px">
                            <div><span style="display:inline-block;width:75px">设备ID:</span>${item.deviceName}</div> 
                            <div><span style="display:inline-block;width:75px">设备别名:</span>${item.anotherName ? item.anotherName : '未设置'
                        }</div> 
                            <div><span style="display:inline-block;width:75px">设备类型:</span>${item.deviceType}</div> 
                            <div><span style="display:inline-block;width:75px;">维护状态:</span><span style="color:${item.maintain == '1' ? '#e83c03' : '#08d97b'
                        }">${item.maintain == '1' ? '维护' : '正常'}</span></div> 
                            <div><span style="display:inline-block;width:75px;">报警状态:</span><span style="color:${item.alarmStatus == 1 ? '#e83c03' : '#08d97b'
                        }">${item.alarmStatus == 1 ? '报警' : '正常'}</span></div> 
                            <div><span style="display:inline-block;width:75px">软件版本:</span>${item.software}</div> 
                            <div><a style="display:inline-block;width:75px"   href="https://iot.sundaytek.com/#/${deviceDetailPagePath}?projectId=${item.projectId
                        }&deviceId=${item.id}">查看详情</a></div> 
                       </div>
                       `;
                    infoWin1.setContent(sContent);
                    marker.addEventListener('click', function () {
                        marker.openInfoWindow(infoWin1);
                    }); // 将标注添加到地图中
                    map.addOverLay(marker);
                });
            } else if (type === -1) {
                // 报警状态
                data.forEach((item, index) => {
                    var latlng = new T.LngLat(item.latitude * 1, item.longitude * 1);
                    var marker = '';
                    var infoWin1 = new T.InfoWindow();

                    let deviceDetailPagePath = '';
                    switch (item.deviceType) {
                        case '智能井盖':
                            deviceDetailPagePath = 'ADeviceDetail';
                            break;
                        case '水位流速监测':
                            deviceDetailPagePath = 'ADeviceDetail1';
                            break;
                        case '雨量监测':
                            deviceDetailPagePath = 'ADeviceDetail2';
                            break;

                        default:
                            break;
                    }

                    switch (item.deviceType) {
                        case '智能井盖':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: jinggaiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: jinggaiGreenIcon });
                            }
                            break;
                        case '水位流速监测':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: shuiweiRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: shuiweiGreenIcon });
                            }
                            break;
                        case '雨量监测':
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: yuliangRedIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: yuliangGreenIcon });
                            }
                            break;

                        default:
                            if (item.alarmStatus === 1) {
                                marker = new T.Marker(latlng, { icon: redIcon });
                            } else {
                                marker = new T.Marker(latlng, { icon: greenIcon });
                            }
                            break;
                    }

                    var sContent = `
                       <div style="font-Size:16px">
                            <div><span style="display:inline-block;width:75px">设备ID:</span>${item.deviceName}</div> 
                             <div><span style="display:inline-block;width:75px">设备别名:</span>${item.anotherName ? item.anotherName : '未设置'
                        }</div> 
                            <div><span style="display:inline-block;width:75px">设备类型:</span>${item.deviceType}</div> 
                            <div><span style="display:inline-block;width:75px;">维护状态:</span><span style="color:${item.maintain == '1' ? '#e83c03' : '#08d97b'
                        }">${item.maintain == '1' ? '维护' : '正常'}</span></div> 
                            <div><span style="display:inline-block;width:75px;">报警状态:</span><span style="color:${item.alarmStatus == 1 ? '#e83c03' : '#08d97b'
                        }">${item.alarmStatus == 1 ? '报警' : '正常'}</span></div> 
                            <div><span style="display:inline-block;width:75px">软件版本:</span>${item.software}</div> 
                            <div><a style="display:inline-block;width:75px"   href="https://iot.sundaytek.com/#/${deviceDetailPagePath}?projectId=${item.projectId
                        }&deviceId=${item.id}">查看详情</a></div> 
                       </div>
                       `;
                    infoWin1.setContent(sContent);
                    marker.addEventListener('click', function () {
                        marker.openInfoWindow(infoWin1);
                    }); // 将标注添加到地图中
                    map.addOverLay(marker);
                });
            }

            // -----------------------
        },

        // 构建地图
        // buildMap(dom, lat, lng, zoom, styleId) {
        //     var map = new BMapGL.Map(dom);
        //     var point = new BMapGL.Point(lat, lng);
        //     map.centerAndZoom(point, zoom);
        //     map.setMapStyleV2({
        //         styleId
        //     });

        //     map.enableScrollWheelZoom(true);
        //     return map;
        // },

        // 增加地图固有控件
        // addControl(map) {
        //     var scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
        //     map.addControl(scaleCtrl);
        //     var zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
        //     map.addControl(zoomCtrl);
        //     var cityCtrl = new BMapGL.CityListControl(); // 添加城市列表控件
        //     map.addControl(cityCtrl);
        // },

        // 自定义增加地图控件
        // setCustomControlClass(map, defaultAnchor, defaultOffsetWidth, defaultOffsetHeight, imgSrc, title, domOpts) {
        //     // 定义一个地图重置控件类
        //     function ResetMapControl() {
        //         // 默认停靠位置和偏移量
        //         this.defaultAnchor = defaultAnchor;
        //         this.defaultOffset = new BMapGL.Size(defaultOffsetWidth, defaultOffsetHeight);
        //     }
        //     // 通过JavaScript的prototype属性继承于BMap.Control
        //     ResetMapControl.prototype = new BMapGL.Control();
        //     // 自定义控件必须实现自己的initialize方法,并且将控件的DOM元素返回
        //     // 在本方法中创建个div元素作为控件的容器,并将其添加到地图容器中
        //     ResetMapControl.prototype.initialize = function (map) {
        //         // 创建一个DOM元素
        //         let div1 = document.createElement('img');
        //         // 设置样式
        //         div1.style.height = '30px';
        //         div1.style.width = '30px';
        //         div1.src = imgSrc;
        //         div1.style.backgroundColor = '#ffffff';
        //         div1.style.padding = '3px';
        //         div1.style.boxSizing = 'border-box';
        //         div1.title = title;
        //         // 绑定事件,重置地图
        //         div1.onclick = domOpts;
        //         // 添加DOM元素到地图中
        //         map.getContainer().appendChild(div1);
        //         // 将DOM元素返回
        //         return div1;
        //     };
        //     // 创建控件
        //     let resetMapCtrl = new ResetMapControl();
        //     // 添加到地图当中
        //     map.addControl(resetMapCtrl);
        // },

        // 地图点聚合功能
        // markerPoly(map) {
        //     var view = new mapvgl.View({
        //         map: map
        //     });
        //     var clusterLayer = new mapvgl.ClusterLayer({
        //         minSize: 30, // 聚合点显示的最小直径
        //         maxSize: 50, // 聚合点显示的最大直径
        //         clusterRadius: 150, // 聚合范围半径
        //         gradient: { 0: 'blue', 0.5: 'green', 1.0: 'red' }, // 聚合点颜色梯度
        //         maxZoom: 15, // 聚合的最大级别，当地图放大级别高于此值将不再聚合
        //         minZoom: 5, // 聚合的最小级别，当地图放大级别低于此值将不再聚合
        //         // 是否显示文字
        //         showText: true,
        //         // 开始聚合的最少点数，点数多于此值才会被聚合
        //         minPoints: 5,
        //         // 设置文字样式
        //         textOptions: {
        //             fontSize: 12,
        //             color: 'white',
        //             // 格式化数字显示
        //             format: function (count) {
        //                 return count >= 10000 ? Math.round(count / 1000) + 'k' : count >= 1000 ? Math.round(count / 100) / 10 + 'k' : count;
        //             }
        //         },
        //         enablePicked: true,
        //         onClick(e) {
        //             console.log(e);
        //             if (e.dataItem != undefined && e.dataItem.deviceName != undefined) {
        //                 // 可通过dataItem下面的children属性拿到被聚合的所有点
        //                 let item = e.dataItem;
        //                 var infoWindow = new BMapGL.InfoWindow(
        //                     `
        //                     <div>设备名称:&nbsp;${e.dataItem.deviceName}</div>
        //                     <div>在线状态:&nbsp;${e.dataItem.onLineStatusT}</div>
        //                     <div>设备类型:&nbsp;${e.dataItem.deviceType}</div>
        //                     <div>软件版本:&nbsp;${e.dataItem.software}</div>
        //                     `,
        //                     {
        //                         width: 100,
        //                         height: 130
        //                     }
        //                 );
        //                 map.openInfoWindow(infoWindow, new BMapGL.Point(item.latitude, item.longitude));
        //             }
        //         }
        //     });

        //     view.addLayer(clusterLayer);

        //     // 判断标记类型
        //     switch (this.markerType) {
        //         case 1:
        //             clusterLayer.setData(this.markerMapData());
        //             // clusterLayer.setData([
        //             //     {
        //             //         geometry: {
        //             //             type: 'Point',
        //             //             coordinates: ['116.39277', '39.906744']
        //             //         },
        //             //         properties: {
        //             //             icon: require('@/assets/mark1.png'),
        //             //             width: 30,
        //             //             height: 30
        //             //         }
        //             //     }
        //             // ]);
        //             break;
        //         case -1:
        //             clusterLayer.setData(this.markerMapDataAlarm());
        //             break;
        //         default:
        //             break;
        //     }
        // },

        // marker在线状态地图定位点数据处理
        // markerMapData() {
        //     let data = JSON.parse(JSON.stringify(this.$store.state.deviceNowData));
        //     console.log('根据在线状态进行数据处理执行');
        //     // let data = this.deviceData;
        //     data.forEach((item, index) => {
        //         data[index].geometry = {
        //             type: 'Point',
        //             coordinates: [item.latitude, item.longitude]
        //         };
        //         data[index].properties = {
        //             width: 30,
        //             height: 30
        //         };
        //         // data[index].lat = item.longitude
        //         // data[index].lng = item.latitude

        //         switch (item.onLineStatus) {
        //             case undefined:
        //                 data[index].properties.icon = require('@/assets/mark1.png');
        //                 data[index].onLineStatusT = '正常';
        //                 break;
        //             case '2':
        //                 data[index].properties.icon = require('@/assets/mark3.png');
        //                 data[index].onLineStatusT = '故障';
        //                 break;
        //             case '1':
        //                 data[index].properties.icon = require('@/assets/mark2.png');
        //                 data[index].onLineStatusT = '维护';
        //                 break;
        //             default:
        //                 break;
        //         }
        //     });

        //     console.log(data);
        //     data.forEach((item, index) => {
        //         data[index].id = null;
        //     });
        //     return data;
        // },
        // marker报警状态地图定位点数据处理
        // markerMapDataAlarm() {
        //     let data = this.deviceData;
        //     data.forEach((item, index) => {
        //         data[index].geometry = {
        //             type: 'Point',
        //             coordinates: [item.latitude, item.longitude]
        //         };
        //         data[index].properties = {
        //             width: 30,
        //             height: 30
        //         };

        //         switch (item.deviceType) {
        //             case '智能井盖':
        //                 if (item.alarmStatus) {
        //                     data[index].properties.icon = require('@/assets/mark3.png');
        //                 } else {
        //                     data[index].properties.icon = require('@/assets/mark1.png');
        //                 }
        //                 break;
        //             case '水位流速监测':
        //                 if (item.alarmStatus) {
        //                     data[index].properties.icon = require('@/assets/mark3.png');
        //                 } else {
        //                     data[index].properties.icon = require('@/assets/mark1.png');
        //                 }
        //                 break;
        //             case '雨量监测':
        //                 if (item.alarmStatus) {
        //                     data[index].properties.icon = require('@/assets/mark3.png');
        //                 } else {
        //                     data[index].properties.icon = require('@/assets/mark1.png');
        //                 }
        //                 break;
        //             default:
        //                 break;
        //         }

        //         switch (item.onLineStatus) {
        //             case undefined:
        //                 data[index].onLineStatusT = '正常';
        //                 break;
        //             case '2':
        //                 data[index].onLineStatusT = '故障';
        //                 break;
        //             case '1':
        //                 data[index].onLineStatusT = '维护';
        //                 break;
        //             default:
        //                 break;
        //         }
        //     });
        //     data.forEach((item, index) => {
        //         data[index].id = null;
        //     });
        //     return data;
        // },

        // 点击报警信息事件
        messDetail(e) {
            console.log(e);
            var point = new T.LngLat(e.lng, e.lat);
            this.mapContle.panTo(point, 18);
        },

        // 统计设备分类数据处理
        typeComputer() {
            let arr = [];

            arr = this.$store.state.deviceNowData.map((item) => {
                return item.deviceType;
            });

            let obj = {};
            for (let i = 0; i < arr.length; i++) {
                var item = arr[i];
                obj[item] = obj[item] + 1 || 1;
            }

            let computerData = [];
            for (const key in obj) {
                computerData.push({
                    name: key,
                    value: obj[key]
                });
            }
            console.log(computerData);
            return computerData;
            // return [
            //     {
            //         name: '智能井盖V3',
            //         value: this.deviceData.length
            //     }
            // ];
        },

        // 统计设备状态数据处理
        statusComputer() {
            let allNumber = this.$store.state.deviceNowData.length;
            let maintainNumber = 0;
            let normalNumber = 0;
            let troubleNumber = 0;

            // 获取维护设备数量
            this.$store.state.deviceNowData.forEach((item, index) => {
                if (item.maintain === '1') {
                    maintainNumber++;
                    this.deviceData[index].onLineStatus = '1';
                }
            });

            // 超时三天未上线即为故障
            this.$store.state.deviceNowData.forEach((item, index) => {
                if (new Date().getTime() - item.updateTime > 7776000000) {
                    troubleNumber++;
                    this.deviceData[index].onLineStatus = '2';
                }
            });

            // 正常设备数量等于总数-故障-维护
            normalNumber = allNumber - maintainNumber - troubleNumber;
            this.computerDataObj = {
                maintainNumber,
                normalNumber,
                troubleNumber
            };
            return [
                {
                    value: normalNumber,
                    name: '正常',
                    itemStyle: { color: '#08d97b' }
                },
                {
                    value: troubleNumber,
                    name: '故障',
                    itemStyle: { color: '#e83c03' }
                },
                {
                    value: maintainNumber,
                    name: '维护',
                    itemStyle: { color: '#ff8115' }
                }
            ];
        },

        // 本月报警次数
        async beforDeviceDataComputerLine() {
            console.log('我启动了');

            let companyId = JSON.parse(localStorage.getItem('companyInfo')).companyId;
            // 获取公司绑定的项目列表
            const projectListResult = await QueryCompanyProject({ companyId: companyId, limit: 100, offset: 0 });
            console.log(projectListResult);
            let projectStr = '';
            let projectRowResult = projectListResult.data.rows;
            projectRowResult.forEach((item, index) => {
                if (index == projectRowResult.length - 1) {
                    projectStr = `${projectStr}${item.projectId}`;
                } else {
                    projectStr = `${projectStr}${item.projectId},`;
                }
            });

            // 开始日期时间戳
            let startTimeStamp = moment().month(moment().month()).startOf('month').valueOf();
            // 结束日期时间戳
            let endTimeStamp = new Date().getTime();
            // 对两个日期进行格式化
            let startDate = moment(startTimeStamp * 1).format('MM-DD');
            let endDate = moment(endTimeStamp * 1).format('MM-DD');
            // 当前月份
            let monthNow = endDate.split('-')[0];
            let xData = [];
            for (let i = 1; i <= endDate.split('-')[1] * 1; i++) {
                // 判断i是否小于10
                if (i < 10) {
                    xData.push(`${monthNow}-0${i}`);
                } else {
                    xData.push(`${monthNow}-${i}`);
                }
            }

            // 调用根据时间戳获取报警数据
            const result = await QueryAlermMessage({
                companyId: companyId,
                projectStr: projectStr,
                startTimeStamp: startTimeStamp,
                endTimeStamp: endTimeStamp
            });

            this.alermMessageData = result.data;
            this.alermMessageTypeComputer();

            let deviceMessageArr = [];
            result.data.forEach((item) => {
                item.date = moment(item.createTime * 1).format('MM-DD');
                deviceMessageArr.push(item.date);
            });

            // 数据
            let vSeries = [];
            // searies数据计算
            xData.forEach((item) => {
                let number = 0;
                deviceMessageArr.forEach((ite) => {
                    if (item == ite) {
                        number++;
                    }
                });
                vSeries.push(number);
            });

            let one = this.$echarts.init(this.$refs.one);

            one.setOption({
                title: {
                    text: '本月报警次数',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    bottom: 25
                },
                xAxis: {
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: vSeries,
                        showSymbol: false,
                        type: 'line',
                        lineStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#e83c03' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.8,
                                        color: '#ff8115' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#08d97b' // 100% 处的颜色
                                    }
                                ],
                                global: false // 缺省为 false
                            }
                        }
                    }
                ]
            });
        },
        // 城市分布统计-地址解析 Geocoder
        async cityGeocoder() {
            let deviceArr = JSON.parse(JSON.stringify(this.$store.state.deviceNowData));
            // 筛选出未设置位置的设备
            let notLocationArr = [];
            let isLocationArr = [];
            deviceArr.forEach((item) => {
                if (!item.latitude || !item.longitude) {
                    notLocationArr.push(item);
                } else {
                    isLocationArr.push(item);
                }
            });
            console.log(notLocationArr);
            console.log(isLocationArr);

            // 定义城市数组
            let cityArr = [];
            let that = this;
            // 天地图地图逆地址解析
            // var myGeo = new T.Geocoder();
            isLocationArr.forEach((item, index) => {
                cityArr.push(item.county);
                if (index == isLocationArr.length - 1) {
                    that.cityComputerBar(cityArr, notLocationArr);
                }
                // 根据坐标得到地址描述
                // myGeo.getLocation(new T.LngLat(item.latitude * 1, item.longitude * 1), async function (result) {
                //     if (result) {
                //         // console.log(result);
                //         cityArr.push(JSON.parse(JSON.stringify(result.addressComponent.county)));
                //         // console.log(cityArr);
                //         // 判断当前是否已经是最后一项
                //         if (index == isLocationArr.length - 1) {
                //             that.cityComputerBar(cityArr, notLocationArr);
                //         }
                //     } else {
                //         notLocationArr.push(item);
                //         // 判断当前是否已经是最后一项
                //         if (index == isLocationArr.length - 1) {
                //             that.cityComputerBar(cityArr, notLocationArr);
                //         }
                //     }
                // });
            });
        },
        // 城市分布统计-绘制图表
        async cityComputerBar(cityArr, notLocationArr) {
            let arr = cityArr;
            let newArr = [...new Set(arr)];
            let lastArr = [];
            newArr.forEach((item) => {
                // console.log(item);
                let num = 0;
                arr.forEach((i) => {
                    if (item == i) {
                        num++;
                    }
                });
                lastArr.push({
                    name: item,
                    num
                });
            });

            // console.log(lastArr);
            // 取消了未定位城市
            // lastArr.push({
            //     name: '未定位',
            //     num: notLocationArr.length
            // });

            // 图表x轴
            let xData = [];
            lastArr.forEach((item) => {
                xData.push(item.name);
            });

            // 如果x轴城市小于6则补充城市
            // let mockCity = ['上海市', '西安市', '武汉市', '苏州市', '深圳市', '杭州市', '宁波市', '汉中市', '宝鸡市'];

            // if (xData.length < 6) {
            //     let length = 6 - xData.length;

            //     // 把x轴已经存在的城市从模拟城市数组中删除
            //     xData.forEach(element => {
            //         mockCity.forEach((item, index) => {
            //             if (element == item) {
            //                 delete mockCity[index];
            //             }
            //         });
            //     });

            //     console.log(mockCity);

            //     for (let i = 0; i < length; i++) {
            //         if (mockCity[i]) {
            //             xData.push(mockCity[i]);
            //             console.log('执行了');
            //         } else {
            //             i++;
            //             length++;
            //             xData.push(mockCity[i]);
            //             console.log('执行了');
            //         }
            //     }
            // }

            // 图表值
            let searies = [];
            lastArr.forEach((item) => {
                searies.push(item.num);
            });

            // 设置一些填充城市

            let two = this.$echarts.init(this.$refs.two);
            two.setOption({
                title: {
                    text: '城区分布统计',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                grid: {
                    bottom: 25
                },
                tooltip: {
                    show: true
                },
                xAxis: {
                    type: 'category',
                    data: xData
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: searies,
                        itemStyle: {
                            normal: {
                                // color: function() {
                                //     return '#' + Math.floor(Math.random() * (256 * 256 * 256 - 1)).toString(16);
                                // }
                                color: '#15c9cb'
                            }
                        },
                        type: 'bar'
                    }
                ]
            });
        },

        // 告警信息类型计算
        async alermMessageTypeComputer() {
            console.log('this.alermMessageData');
            console.log(this.alermMessageData);
            let ceshi = 0;
            let wubao = 0;
            let yanlian = 0;
            let baojing = 0;
            this.alermMessageData.forEach((item) => {
                switch (item.type) {
                    case '1':
                        baojing++;
                        break;
                    case '2':
                        baojing++;
                        // yanlian++;
                        break;
                    case '3':
                        baojing++;
                        // wubao++;
                        break;
                    case '4':
                        baojing++;
                        // ceshi++;
                        break;
                    default:
                        break;
                }
            });

            let four = this.$echarts.init(this.$refs.four);
            // 告警信息类型
            four.setOption({
                grid: {
                    bottom: 25
                },
                title: {
                    text: '本月告警类型',
                    left: 'left',
                    textStyle: {
                        color: '#ffffff'
                    }
                },
                tooltip: {
                    trigger: 'item'
                },
                // legend: {
                //     orient: 'vertical',
                //     left: 'right',
                //     textStyle: {
                //         color: '#ffffff'
                //     }
                // },
                series: [
                    {
                        name: '告警信息类型',
                        type: 'pie',
                        radius: ['40%', '50%'],
                        data: [
                            {
                                value: ceshi,
                                name: '测试',
                                itemStyle: {
                                    color: '#909399'
                                }
                            },
                            {
                                value: wubao,
                                name: '误报',
                                itemStyle: {
                                    color: '#409eff'
                                }
                            },
                            {
                                value: yanlian,
                                name: '演练',
                                itemStyle: {
                                    color: '#67c23a'
                                }
                            },
                            {
                                value: baojing,
                                name: '报警',
                                itemStyle: {
                                    color: '#e73a03'
                                }
                            }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            });
        },

        // 网页全屏
        fullPage() {
            if (this.fullscreen) {
                // 退出页面全屏
                screenfull.exit();
                this.fullscreen = !this.fullscreen;
            } else {
                // 页面全屏
                screenfull.request();
                this.fullscreen = !this.fullscreen;
            }
        },

        // 跳转管理后台
        goAdminSystem() {
            // this.$message.warning('平台转移中,暂未开放');
            // return;

            let companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
            if (companyInfo.companyId == 1) {
                this.$router.push('/ADashboard');
            } else {
                this.$router.push('/ADashboard');
            }
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        // this.webSocket.close();
    }
};
</script>
<style lang="less" scoped>
.home {
    width: 100%;
    height: 100%;

    text-align: center;
    color: #2c3e50;
}

.bg {
    background-image: url('../../assets/loginbg.png');
    background-size: 100% 100%;
}

img {
    width: 1rem;
}

.title {
    display: flex;
    justify-content: center;
    position: relative;
}

.titleText {
    position: absolute;
    margin: 0 auto;
    color: #15c9cb;
    font-size: 0.8rem;
}

.top {
    display: flex;
    justify-content: space-between;
    padding: 0 1rem;
    box-sizing: border-box;
    height: 12vh;
    padding-top: 0.5rem;

    .time {
        width: 20%;
        font-size: 0.5rem;
        color: #15c9cb;
        display: flex;
        align-items: center;
    }

    .title {
        width: 60%;
    }

    .menu {
        width: 20%;
        font-size: 0.25rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .menuList {
            display: flex;
            height: 100%;
            align-items: center;
            color: #fff;
            margin-right: 0.2rem;

            .icon {
                display: flex;
                align-items: center;

                img {
                    width: 0.4rem;
                    height: 0.4rem;
                    margin-right: 0.05rem;
                }
            }

            .text {
                cursor: pointer;
            }
        }

        // .menuList:hover {
        //     color: #15c9cb;
        // }
    }
}

.midf {
    height: 60vh;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0.2rem;
    box-sizing: border-box;
    justify-content: space-between;

    .left {
        width: 25%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .top {
            padding: 0.5rem;
            display: flex;
            align-items: center;
            padding-bottom: 0;
            box-sizing: border-box;
            height: 30%;

            .content {
                font-size: 0.4rem;
                flex: 1;
                height: 100%;
                display: flex;
                align-items: center;

                .contentBox {
                    display: flex;
                    flex-wrap: wrap;
                    height: 100%;
                    align-items: center;
                    justify-content: space-around;
                    padding: 0 0.5rem;
                    color: #fff;

                    .contentlist {
                        border-bottom: 1px solid #ccc;
                        cursor: default;
                    }

                    // .contentlist:hover {
                    //     color: #15c9cb;
                    //     cursor: pointer;
                    // }
                }
            }

            .content::-webkit-scrollbar {
                display: none;
            }
        }

        .bot {
            flex: 1;
            height: 70%;
        }
    }

    .map {
        width: 48%;
        height: 100%;
        position: relative;

        .mapBox {
            width: 100%;
            height: 100%;
            // background-color: #090a0a !important;
        }

        .searchMenu {
            position: absolute;
            top: 10px;
            left: 50%;
            margin-left: -175px;
            width: 400px;
            z-index: 99;
            font-size: 0.5rem;
        }
    }

    .right {
        width: 25%;
        height: 100%;

        .top {
            font-size: 0.4rem;
            width: 100%;
            height: 30%;

            .left {
                height: 3rem;
                width: 3rem;
                position: relative;

                .number {
                    color: #d4004f;
                }
            }

            .right {
                height: 3rem;
                position: relative;
                width: 3rem;

                .number {
                    color: #00a8ff;
                }
            }

            img {
                height: 3rem;
                width: 3rem;
            }

            .text {
                position: absolute;
                top: 0;
                width: 3rem;
                height: 3rem;
                color: #fff;
                left: 50%;
                margin-left: -1.5rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
                text-align: center;
                align-items: left;

                .number {
                    text-align: center;
                    font-size: 0.5rem;
                    font-weight: bold;
                }
            }
        }

        .bot {
            display: flex;
            flex-direction: column;

            .botBtn {
                margin-top: 0.1rem;
                display: flex;
                justify-content: space-around;
                font-size: 0.4rem;
                color: #fff;
                text-align: center;

                img {
                    width: 2rem;
                    height: 0.7rem;
                }

                .botBtn1 {
                    position: relative;

                    .botText {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 2rem;
                        height: 0.7rem;
                        line-height: 0.7rem;
                    }
                }

                .botBtn2 {
                    position: relative;

                    .botText {
                        position: absolute;
                        left: 0;
                        width: 2rem;
                        height: 0.7rem;
                        line-height: 0.7rem;
                        cursor: pointer;
                        top: 0;
                    }
                }
            }

            .botCon {
                flex: 1;
                font-size: 0.4rem;
                max-height: 7rem;
                text-align: left;
                overflow: scroll;
                color: #fff;
                padding-left: 0.5rem;
                padding-top: 0.2rem;
                box-sizing: border-box;
                cursor: pointer;
            }

            .alarm {
                color: #e83c03;
            }

            .troule {
                color: #ff8115;
            }

            .botConList:hover {
                color: #15c9cb;
            }

            .botCon::-webkit-scrollbar {
                display: none;
            }
        }
    }
}

.bot {
    width: 100%;
    padding: 0 0.3rem;
    height: 28vh;
    box-sizing: border-box;
    display: flex;

    .botL {
        width: 25%;
        height: 28vh;
        // border: 1px solid red;
        box-sizing: border-box;
    }

    .one {}

    .two {}

    .three {}

    .four {}
}

.selectBotText {
    color: #15c9cb;
    cursor: pointer;
}

// 主题色 #15c9cb</style>
